import { HttpService } from "../http";

export class SubsubscriberService extends HttpService {
  baseAuthUrl = process.env.REACT_APP_BASE_URL;
  fetchSubSubscriber = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseAuthUrl}/api/organization-membership/sub-subscriber`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addSubSubscriber = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseAuthUrl}/api/organization-membership/sub-subscriber`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteSubscriber = async (id: any): Promise<any> => {
    const baseUrl = `${this.baseAuthUrl}/api/organization-membership/sub-subscriber/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
